module.exports = __webpack_public_path__ + "883029ab9959577a7d55dc5b1b270c11.svg";